export default __webpack_public_path__ + "static/media/groundnut.bc3eb694.JPG";